// @ts-expect-error file not converted to TS yet
import Cookie from 'js-cookie';
import { LOGIN_METADATA_COOKIE_NAME } from '../constants/cookies';
import { getDomain } from './urls';
export const setLoginMetadataCookieEnableAll = () => {
  Cookie.set(LOGIN_METADATA_COOKIE_NAME, JSON.stringify({
    ungatedForLoginV4: true,
    showABTestVariant: true,
    isMobileLogin: true
  }), {
    domain: getDomain()
  });
};
const getParsedLoginMetadataCookie = () => {
  const loginMetadataCookie = Cookie.get(LOGIN_METADATA_COOKIE_NAME);
  return JSON.parse(loginMetadataCookie.replace(/\\"/g, '"'));
};
export const getIsUngatedForLoginV4 = () => {
  try {
    const loginMetadata = getParsedLoginMetadataCookie();
    return loginMetadata.ungatedForLoginV4;
  } catch (_unused) {
    return false;
  }
};
export const getShowABTestVariant = () => {
  try {
    const loginMetadata = getParsedLoginMetadataCookie();
    return loginMetadata.showABTestVariant;
  } catch (_unused2) {
    return null;
  }
};
export const getReauthCookieValue = () => {
  return Cookie.get('hs_reauth');
};